import React, { useEffect, useState } from 'react';
import { apiGet, apiPost } from '../../../API/Api_Url';
import { X, MapPin, Calendar, DollarSign, FileCheck, Menu, MoreVertical } from 'lucide-react';
import { FaCheckCircle, FaEdit, FaEye, FaTrashAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import UpdateFreelancerJobPostModel from '../../Modal/UpdateFreelancerJobPostModel';
import DeleteFreelancerJobPostModel from '../../Modal/DeleteFreelancerJobPostModel';
import { toast } from 'react-toastify';

function UserAllPendingFreelancerJobPost({ RequirementState, setRequirementState }) {
    const navigate = useNavigate();
    const [FreelancerJobPost, setFreelancerJobPost] = useState([]);
    const [isUploading, setIsUploading] = useState(false);

    const GetUserAllPendingFreelancerJobPost = async () => {
        try {
            setIsUploading(true);
            const response = await apiGet('api/user/UserGetAllPendingFreelancerJobPost');
            setFreelancerJobPost(response.data);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsUploading(false);
        }
    };

    useEffect(() => {
        GetUserAllPendingFreelancerJobPost();
    }, []);

    const [Allbids, setAllbids] = useState([]);
    const [IsbidLoading, setIsbidLoading] = useState(false);

    const GetAllbidofJobPost = async (id) => {
        try {
            setIsbidLoading(true)
            const response = await apiGet(`api/user/UserGetAllbidofJobPost/${id}`);
            setAllbids(response?.data);
            setIsbidLoading(false)
        } catch (error) {
            setIsbidLoading(false)
            console.error('Error fetching data:', error);
        } finally {
            setIsbidLoading(false)
        }
    };


    const UserFinalizeFreelancerJobBid = async (jobPostId, bidId) => {
        try {
            const data = {
                jobPostId,
                bidId
            }
            setIsUploading(true);
            const response = await apiPost('api/user/UserFinalizeFreelancerJobBid', data);
            toast.success(response?.message || 'Bid Finlize completed')
            GetUserAllPendingFreelancerJobPost()
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsUploading(false);
        }
    };


    const [expandedJob, setExpandedJob] = useState(null);

    const toggleBids = async (reqId) => {
        if (expandedJob === reqId) {
            setExpandedJob(null);
            setAllbids([]);
        } else {
            await GetAllbidofJobPost(reqId);
            setExpandedJob(reqId);
        }
    };


    const [SelectedRequirement, setSelectedRequirement] = useState(null);
    const [UpdateModel, setUpdateModel] = useState(false);


    const OpenUpdateModel = (req) => {
        setUpdateModel(true)
        setSelectedRequirement(req)
    }

    const CloseUpdateModel = () => {
        setUpdateModel(false)
        setSelectedRequirement(null)
    }


    const [DeleteModel, setDeleteModel] = useState(false);

    const OpendeleteModel = (req) => {
        setDeleteModel(true)
        setSelectedRequirement(req)
    }

    const CloseDeleteModel = () => {
        setDeleteModel(false)
        setSelectedRequirement(null)
    }



    const getStatusColor = (status) => {
        switch (status) {
            case 'Pending':
                return 'bg-yellow-100 text-yellow-800 border-yellow-200';
            case 'Approved':
            case 'Accepted':
                return 'bg-green-100 text-green-800 border-green-200';
            case 'Rejected':
                return 'bg-red-100 text-red-800 border-red-200';
            default:
                return 'bg-gray-100 text-gray-800 border-gray-200';
        }
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };

    return (
        <div className="p-6 bg-gradient-to-br from-blue-50 to-indigo-100 min-h-screen">
            <div className="max-w-7xl mx-auto">
                <div className="mb-8 flex flex-col md:flex-row md:items-center md:justify-between">
                    <div>
                        <h1 className="text-3xl font-bold text-gray-900 mb-1 md:mb-0">
                            My All Pending Freelancer Job Posts
                        </h1>
                        <p className="text-gray-600">Manage and track your freelancer job posts</p>
                    </div>

                    <div className="mt-4 md:mt-0">
                        <select
                            value={RequirementState}
                            onChange={(e) => setRequirementState(e.target.value)}
                            className="border border-gray-300 rounded-lg px-4 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#0060B9]"
                        >
                            <option value="All">All</option>
                            <option value="pending">Pending</option>
                            <option value="Selected">Selected</option>
                            <option value="AgreementPending">Agreement Pending</option>
                            <option value="InConstruction">In Construction</option>
                            <option value="Completed">Completed</option>
                        </select>
                    </div>
                </div>

                {isUploading ? (
                    <div className="flex items-center justify-center py-20">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
                        <p className="ml-4 text-gray-600">Loading your projects...</p>
                    </div>
                ) : FreelancerJobPost?.length === 0 ? (
                    <div className="text-center py-20">
                        <p className="text-xl text-gray-500">No Freelancer Job Posts found.</p>
                        <p className="text-gray-400 mt-2">Create your first job post to get started.</p>
                    </div>
                ) : (
                    <div className="grid gap-6 grid-cols-1">
                        {FreelancerJobPost?.map((req) => (
                            <div key={req?._id} className="bg-white rounded-2xl shadow-lg p-6">
                                <div className="flex justify-between items-start mb-4">
                                    <h3 className="text-xl font-bold text-gray-900">{req?.Title}</h3>
                                    <span
                                        className={`px-3 py-1 text-xs font-semibold rounded-full border ${getStatusColor(req?.Status)}`}
                                    >
                                        {req?.Status}
                                    </span>
                                </div>

                                <p className="text-gray-700 mb-3">{req?.Description}</p>

                                {req?.Skillsrequire?.length > 0 && (
                                    <p className="text-sm text-gray-600 mb-3">
                                        <span className="font-medium">Skills Required:</span>{" "}
                                        {req?.Skillsrequire.join(", ")}
                                    </p>
                                )}

                                <div className="grid grid-cols-2 gap-4 text-sm mb-4">
                                    <div className="flex items-center text-gray-700">
                                        <DollarSign className="h-4 w-4 mr-2 text-purple-500" />
                                        <p>
                                            <span className="font-medium">Budget:</span> ₹{req?.Budget}
                                        </p>
                                    </div>

                                    <div className="flex items-center text-gray-700">
                                        <Calendar className="h-4 w-4 mr-2 text-orange-500" />
                                        <p>
                                            <span className="font-medium">Timeline:</span>{" "}
                                            {formatDate(req?.timeline?.startDate)} -{" "}
                                            {formatDate(req?.timeline?.endDate)}
                                        </p>
                                    </div>
                                </div>

                                {req?.location && (
                                    <div className="flex items-start text-gray-600 mb-4">
                                        <MapPin className="h-4 w-4 mr-2 mt-0.5 text-blue-500" />
                                        <p className="text-sm">
                                            {req?.location?.Address}, {req?.location?.City},{" "}
                                            {req?.location?.State}
                                        </p>
                                    </div>
                                )}

                                <div className="mt-6 flex justify-between items-center text-sm text-gray-500">
                                    <span className="flex items-center">
                                        <Calendar className="h-4 w-4 mr-1" />
                                        Created: {formatDate(req?.createdAt)}
                                    </span>

                                    <div className="flex items-center gap-2">
                                        <button
                                            onClick={() => OpenUpdateModel(req)}
                                            className="flex items-center gap-1 px-3 py-1 text-sm bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition"
                                        >
                                            <FaEdit className="h-4 w-4" />
                                            Update
                                        </button>

                                        <button
                                            onClick={() => OpendeleteModel(req)}
                                            className="flex items-center gap-1 px-3 py-1 text-sm bg-red-500 text-white rounded-lg hover:bg-red-600 transition"
                                        >
                                            <FaTrashAlt className="h-4 w-4" />
                                            Delete
                                        </button>

                                        <button
                                            // onClick={() => navigate(`/FreelancerJobPostDetail/${req?._id}`)}
                                            className="flex items-center gap-1 px-3 py-1 text-sm bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition"
                                        >
                                            <FaEye className="h-4 w-4" /> View Details
                                        </button>
                                    </div>
                                    <button
                                        onClick={() => toggleBids(req?._id)}
                                        className="mt-3 text-sm text-blue-600 hover:underline flex items-center gap-2"
                                        disabled={IsbidLoading}
                                    >
                                        {IsbidLoading && expandedJob === req?._id ? (
                                            <>
                                                <div className="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                                                <span>Loading...</span>
                                            </>
                                        ) : expandedJob === req?._id ? (
                                            "Hide Bids"
                                        ) : (
                                            "Show Bids"
                                        )}
                                    </button>
                                </div>
                                {expandedJob === req?._id && (
                                    <div className="mt-4 border-t pt-4 space-y-4">
                                        {isUploading ? (
                                            <p className="text-gray-500 text-center">Loading bids...</p>
                                        ) : Allbids?.length === 0 ? (
                                            <p className="text-gray-500 text-center">No bids found for this job post.</p>
                                        ) : (
                                            Allbids?.map((bid) => (
                                                <div
                                                    key={bid?._id}
                                                    className="bg-gradient-to-r from-white to-gray-50 border border-gray-200 rounded-2xl shadow-sm hover:shadow-md transition p-5"
                                                >
                                                    <div className="flex justify-between items-center mb-3">
                                                        <h4 className="text-base font-semibold text-gray-900">
                                                            💬 Proposal
                                                        </h4>
                                                        <span
                                                            className={`px-3 py-1 text-xs font-medium rounded-full ${bid?.Status === "Pending"
                                                                ? "bg-yellow-100 text-yellow-800"
                                                                : bid?.Status === "Accepted"
                                                                    ? "bg-green-100 text-green-800"
                                                                    : "bg-red-100 text-red-800"
                                                                }`}
                                                        >
                                                            {bid?.Status}
                                                        </span>
                                                    </div>

                                                    <p className="text-gray-700 text-sm mb-4 leading-relaxed">
                                                        {bid?.Note}
                                                    </p>

                                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm text-gray-600 mb-4">
                                                        <div className="flex items-center">
                                                            <span className="mr-2">💰</span>
                                                            <span>
                                                                <span className="font-medium">Proposed Price:</span> ₹{bid?.ProposedPrice}
                                                            </span>
                                                        </div>
                                                        <div className="flex items-center">
                                                            <span className="mr-2">📅</span>
                                                            <span>
                                                                <span className="font-medium">Timeline:</span>{" "}
                                                                {new Date(bid?.Timeline?.startDate).toLocaleDateString()} -{" "}
                                                                {new Date(bid?.Timeline?.endDate).toLocaleDateString()}
                                                            </span>
                                                        </div>
                                                        <div className="flex items-center">
                                                            <span className="mr-2">🕒</span>
                                                            <span>
                                                                <span className="font-medium">Created:</span>{" "}
                                                                {new Date(bid?.createdAt).toLocaleDateString()}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div className="flex justify-end">
                                                        <button
                                                            onClick={() => UserFinalizeFreelancerJobBid(req?._id, bid?._id)}
                                                            className="px-4 py-2 text-sm bg-green-500 text-white rounded-lg shadow hover:bg-green-600 focus:ring-2 focus:ring-green-300 transition"
                                                        >
                                                            ✅ Select This Bid
                                                        </button>
                                                    </div>
                                                </div>
                                            ))
                                        )}
                                    </div>

                                )}
                            </div>
                        ))}
                    </div>
                )}
            </div>
            <UpdateFreelancerJobPostModel
                SelectedRequirement={SelectedRequirement}
                isOpen={UpdateModel}
                onClose={CloseUpdateModel}
                GetUserAllPendingFreelancerJobPost={GetUserAllPendingFreelancerJobPost}
            />
            <DeleteFreelancerJobPostModel
                SelectedRequirement={SelectedRequirement}
                isOpen={DeleteModel}
                onClose={CloseDeleteModel}
                GetUserAllPendingFreelancerJobPost={GetUserAllPendingFreelancerJobPost}
            />
        </div>
    );
}

export default UserAllPendingFreelancerJobPost;
